(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const html = document.documentElement;
  const config = JSON.parse($('#gaminuConfig')?.textContent || '{}');
  const root = (config.root || window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const lt = html.lang.startsWith('lt');
  const t = (en, lithuanian) => lt ? lithuanian : en;

  // Product-card/detail REQUEST RESTOCK links prefill the existing Shopify contact form.
  // The user can edit the request before submitting; ordinary contact visits stay untouched.
  const restockParams = new URLSearchParams(location.search);
  const restockContactForm = $('#gaminuContactForm');
  if (restockContactForm && restockParams.get('restock') === '1') {
    // Shopify supports contact[phone]. Require both phone and email on restock
    // requests, without changing the ordinary contact form.
    const restockPhoneField = $('#gaminuRestockPhoneField', restockContactForm);
    const restockPhone = $('#gaminuRestockPhone', restockContactForm);
    if (restockPhoneField && restockPhone) {
      restockPhoneField.hidden = false;
      restockPhone.disabled = false;
      restockPhone.required = true;
      const phoneRequiredMessage = t('Please enter your phone number.', 'Įveskite telefono numerį.');
      restockPhone.addEventListener('input', () => {
        // Native required handles empty input; this also rejects whitespace-only input.
        restockPhone.setCustomValidity(restockPhone.value && !restockPhone.value.trim() ? phoneRequiredMessage : '');
      });
      restockContactForm.addEventListener('submit', (event) => {
        restockPhone.value = restockPhone.value.trim();
        if (!restockPhone.value) {
          event.preventDefault();
          restockPhone.setCustomValidity(phoneRequiredMessage);
          restockPhone.reportValidity();
        }
      });
    }
    const productName = (restockParams.get('product') || '').trim();
    if (productName) {
      const variantTitle = (restockParams.get('variant') || '').trim();
      const variantId = (restockParams.get('variant_id') || '').trim();
      const variantLine = variantTitle && variantTitle !== 'Default Title'
        ? `\n${t('Variant', 'Variantas')}: ${variantTitle}` : '';
      let sourceLink = '';
      const productPath = restockParams.get('product_url') || '';
      // Only build an internal product URL; never accept a third-party destination.
      if (productPath.startsWith('/') && !productPath.startsWith('//')) {
        const sourceUrl = new URL(productPath, location.origin);
        if (sourceUrl.origin === location.origin && sourceUrl.pathname.includes('/products/')) {
          if (/^\d+$/.test(variantId)) sourceUrl.searchParams.set('variant', variantId);
          sourceLink = sourceUrl.href;
        }
      }
      const subject = $('input[name="contact[subject]"]', restockContactForm);
      const body = $('textarea[name="contact[body]"]', restockContactForm);
      if (subject && !subject.value.trim()) {
        subject.value = t(`Restock request: ${productName}`, `Užklausa dėl papildymo: ${productName}`);
      }
      if (body && !body.value.trim()) {
        body.value = t(
          `Hello,\nI would like to know when this product will be available again.\n\nProduct: ${productName}${variantLine}${sourceLink ? `\nProduct link: ${sourceLink}` : ''}\n\nThank you.`,
          `Sveiki,\nNorėčiau sužinoti, kada šią prekę vėl turėsite sandėlyje.\n\nPrekė: ${productName}${variantLine}${sourceLink ? `\nPrekės nuoroda: ${sourceLink}` : ''}\n\nAčiū.`
        );
      }
    }
  }

  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => new Intl.NumberFormat(html.lang || 'en', {style:'currency', currency:config.currency || 'EUR'}).format((cents || 0) / 100);
  const predictivePrice = product => {
    const raw = product?.price ?? product?.price_min ?? product?.price_minimum ?? product?.variants?.[0]?.price;
    if (raw == null || raw === '') return '';
    if (typeof raw === 'object' && raw.amount != null) return new Intl.NumberFormat(html.lang || 'en', {style:'currency', currency:raw.currency_code || config.currency || 'EUR'}).format(Number(raw.amount));
    if (typeof raw === 'number') return new Intl.NumberFormat(html.lang || 'en', {style:'currency', currency:config.currency || 'EUR'}).format(raw);
    const value = String(raw).trim();
    if (!value) return '';
    if (/[^0-9.,\s-]/.test(value)) return value;
    const numeric = Number(value.replace(/\s/g, '').replace(',', '.'));
    return Number.isFinite(numeric) ? new Intl.NumberFormat(html.lang || 'en', {style:'currency', currency:config.currency || 'EUR'}).format(numeric) : value;
  };
  try { html.dataset.theme = localStorage.getItem('gaminu-theme') || 'light'; } catch { html.dataset.theme = 'light'; }
  const themeButtons = $$('[data-gaminu-theme-toggle]');
  const syncTheme = () => {
    const dark = html.dataset.theme === 'dark';
    themeButtons.forEach(button => {
      button.setAttribute('aria-label', dark ? t('Switch to light mode','Perjungti į šviesų režimą') : t('Switch to dark mode','Perjungti į tamsų režimą'));
      button.setAttribute('aria-pressed', String(dark));
      button.title = dark ? t('Light mode','Šviesus režimas') : t('Dark mode','Tamsus režimas');
      const label = $('[data-theme-label]', button);
      if (label) label.textContent = dark ? t('Light mode','Šviesus režimas') : t('Dark mode','Tamsus režimas');
    });
  };
  const toggleTheme = () => {
    html.dataset.theme = html.dataset.theme === 'dark' ? 'light' : 'dark';
    try { localStorage.setItem('gaminu-theme', html.dataset.theme); } catch { /* Preference remains active for this page. */ }
    syncTheme();
  };
  syncTheme();
  themeButtons.forEach(button => button.addEventListener('click', toggleTheme));

  // Navigation labels stay static; no rolling duplicate-text animation.
  const menu = $('#gaminuMobilePanel'), menuBg = $('#gaminuMobileBackdrop');
  const drawer = $('#gaminuDrawer'), drawerBg = $('#gaminuDrawerBackdrop');
  const filterPanel = $('#gaminuFiltersPanel'), filterBg = $('#gaminuFilterBackdrop');
  let previousFocus;
  const lock = () => document.body.classList.toggle('no-scroll', !!(menu?.classList.contains('open') || drawer?.classList.contains('open') || filterPanel?.classList.contains('open')));
  function setPanel(panel, backdrop, open) {
    if (!panel) return;
    panel.classList.toggle('open', open); backdrop?.classList.toggle('open', open);
    panel.inert = !open;
    lock();
    if (open) { previousFocus = document.activeElement; $('button,input,a', panel)?.focus(); }
    else previousFocus?.focus();
  }
  if (menu) menu.inert = true;
  if (drawer) drawer.inert = true;
  const menuButton = $('#gaminuMenuToggle');
  const openMenu = () => { setPanel(menu, menuBg, true); menuButton?.setAttribute('aria-expanded', 'true'); };
  const closeMenu = () => { setPanel(menu, menuBg, false); menuButton?.setAttribute('aria-expanded', 'false'); };
  menuButton?.setAttribute('aria-expanded', 'false');
  menuButton?.addEventListener('click', openMenu);
  $('#gaminuMobileSearch')?.addEventListener('click', () => { openMenu(); $('input[type=search]', menu)?.focus(); });
  $('#gaminuMobileClose')?.addEventListener('click', closeMenu); menuBg?.addEventListener('click', closeMenu);
  $$('.mobile-links a', menu || document).forEach(link => link.addEventListener('click', closeMenu));
  const mobileBreakpoint = window.matchMedia('(max-width: 900px)');
  const filterOpenButton = $('#gaminuFilterOpen');
  const setFilters = open => {
    if (!filterPanel || !mobileBreakpoint.matches) return;
    filterPanel.classList.toggle('open', open);
    filterBg?.classList.toggle('open', open);
    filterOpenButton?.setAttribute('aria-expanded', String(open));
    lock();
    if (open) window.setTimeout(() => $('#gaminuFilterClose')?.focus(), 40);
  };
  const closeFilters = () => setFilters(false);
  filterOpenButton?.addEventListener('click', () => setFilters(true));
  $('#gaminuFilterClose')?.addEventListener('click', closeFilters);
  filterBg?.addEventListener('click', closeFilters);
  const syncMobilePanel = event => {
    if (!event.matches) {
      if (menu?.classList.contains('open')) closeMenu();
      if (filterPanel?.classList.contains('open')) {
        filterPanel.classList.remove('open'); filterBg?.classList.remove('open'); filterOpenButton?.setAttribute('aria-expanded','false'); lock();
      }
    }
  };
  mobileBreakpoint.addEventListener?.('change', syncMobilePanel);
  const closeDrawer = () => setPanel(drawer, drawerBg, false);
  $('#gaminuCartClose')?.addEventListener('click', closeDrawer); drawerBg?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { if (menu?.classList.contains('open')) closeMenu(); if (drawer?.classList.contains('open')) closeDrawer(); if (filterPanel?.classList.contains('open')) closeFilters(); $('#gaminuLanguage')?.removeAttribute('open'); }
    const panel = drawer?.classList.contains('open') ? drawer : menu?.classList.contains('open') ? menu : filterPanel?.classList.contains('open') ? filterPanel : null;
    if (e.key !== 'Tab' || !panel) return;
    const controls = $$('a[href],button:not(:disabled),input:not([type=hidden]),select,[tabindex="0"]', panel).filter(el => el.getClientRects().length);
    if (e.shiftKey && document.activeElement === controls[0]) { e.preventDefault(); controls.at(-1)?.focus(); }
    else if (!e.shiftKey && document.activeElement === controls.at(-1)) { e.preventDefault(); controls[0]?.focus(); }
  });
  document.addEventListener('click', e => { if (!e.target.closest('#gaminuLanguage')) $('#gaminuLanguage')?.removeAttribute('open'); });
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); } }), {threshold:.06}) : null;
  function reveal(scope = document) { $$('.reveal', scope).forEach(el => observer ? observer.observe(el) : el.classList.add('visible')); }
  reveal(); document.addEventListener('shopify:section:load', e => reveal(e.target));

  // Same soft cursor-following light used by the TECHMI cards.
  const spotlightSelector = '.hero-main,.hero-sale-card,.trust-item,.product-card,.category-card,.story-panel,.promo-large,.promo-small,.about-card,.review-card,.help-cta,.contact-card,.map-card,.filters,.product-gallery,.product-info,.product-detail-lower,.faq-item,.gaminu-cart-item,.nav-mega-grid';
  const spotlightEnabled = window.matchMedia('(pointer:fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initSpotlights(scope = document) {
    if (!spotlightEnabled) return;
    const targets = [];
    if (scope.matches?.(spotlightSelector)) targets.push(scope);
    targets.push(...$$(spotlightSelector, scope));
    targets.forEach(el => {
      if (el.dataset.spotlightReady === 'true') return;
      el.dataset.spotlight = '';
      el.dataset.spotlightReady = 'true';
      el.addEventListener('pointermove', e => {
        const rect = el.getBoundingClientRect();
        el.style.setProperty('--mx', `${e.clientX - rect.left}px`);
        el.style.setProperty('--my', `${e.clientY - rect.top}px`);
      }, {passive:true});
    });
  }
  initSpotlights();
  document.addEventListener('shopify:section:load', e => initSpotlights(e.target));

  // Animate UI-inspired counting number for the sale price. The existing shiny text stays intact.
  function moneyTemplateFormatter(finalText) {
    const match = String(finalText || '').match(/\d(?:[\d.,\s]*\d)?/);
    if (!match) return value => String(value);
    const token = match[0];
    const prefix = finalText.slice(0, match.index);
    const suffix = finalText.slice((match.index || 0) + token.length);
    const decimalMatch = token.match(/([.,])(\d{1,2})$/);
    const decimalSeparator = decimalMatch?.[1] || '.';
    const decimalPlaces = decimalMatch?.[2]?.length ?? 2;
    return value => {
      const fixed = Math.max(0, value).toFixed(decimalPlaces);
      const rendered = decimalSeparator === ',' ? fixed.replace('.', ',') : fixed;
      return `${prefix}${rendered}${suffix}`;
    };
  }

  function initCountingPrices(scope = document) {
    const targets = [];
    if (scope.matches?.('[data-counting-price]')) targets.push(scope);
    targets.push(...$$('[data-counting-price]', scope));
    targets.forEach(el => {
      if (el.dataset.countingReady === 'true') return;
      el.dataset.countingReady = 'true';
      const targetCents = Number(el.dataset.priceCents || 0);
      const finalText = el.dataset.finalPrice || el.textContent || '';
      const format = moneyTemplateFormatter(finalText);
      if (!Number.isFinite(targetCents) || targetCents <= 0 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = finalText;
        return;
      }

      const run = () => {
        const duration = 1250;
        const startedAt = performance.now();
        const tick = now => {
          const t = Math.min(1, (now - startedAt) / duration);
          const eased = 1 - Math.pow(1 - t, 4);
          const currentCents = Math.round(targetCents * eased);
          el.textContent = format(currentCents / 100);
          if (t < 1) requestAnimationFrame(tick);
          else el.textContent = finalText;
        };
        requestAnimationFrame(tick);
      };

      if ('IntersectionObserver' in window) {
        const countObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            countObserver.disconnect();
            run();
          }
        }, { threshold: .45 });
        countObserver.observe(el);
      } else run();
    });
  }
  initCountingPrices();
  document.addEventListener('shopify:section:load', e => initCountingPrices(e.target));

  // Animate UI-inspired tilt for the four trust cards, layered on top of their existing float/glow/border effects.
  const tiltEnabled = window.matchMedia('(pointer:fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initTrustTilt(scope = document) {
    if (!tiltEnabled) return;
    const cards = [];
    if (scope.matches?.('.trust-item')) cards.push(scope);
    cards.push(...$$('.trust-item', scope));
    cards.forEach(card => {
      if (card.dataset.tiltReady === 'true') return;
      card.dataset.tiltReady = 'true';
      let frame = 0;
      let nextX = 0;
      let nextY = 0;
      const commit = () => {
        frame = 0;
        card.style.setProperty('--gaminu-tilt-x', `${nextX.toFixed(2)}deg`);
        card.style.setProperty('--gaminu-tilt-y', `${nextY.toFixed(2)}deg`);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(commit); };
      card.addEventListener('pointermove', e => {
        const rect = card.getBoundingClientRect();
        const px = Math.max(0, Math.min(1, (e.clientX - rect.left) / Math.max(1, rect.width)));
        const py = Math.max(0, Math.min(1, (e.clientY - rect.top) / Math.max(1, rect.height)));
        const maxTilt = 8;
        nextX = (0.5 - py) * maxTilt * 2;
        nextY = (px - 0.5) * maxTilt * 2;
        schedule();
      }, { passive:true });
      card.addEventListener('pointerleave', () => {
        nextX = 0;
        nextY = 0;
        schedule();
      }, { passive:true });
    });
  }
  initTrustTilt();
  document.addEventListener('shopify:section:load', e => initTrustTilt(e.target));

  // The hero word carousel is CSS-only to match the supplied Uiverse vertical loader animation.

  document.addEventListener('click', e => { const button = e.target.closest('.faq-q'); if (button) button.setAttribute('aria-expanded', String(button.closest('.faq-item').classList.toggle('open'))); });
  async function api(path, options = {}) {
    const response = await fetch(root + path, {...options, headers:{Accept:'application/json', ...options.headers}});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || t('Unable to complete the request.', 'Nepavyko įvykdyti užklausos.'));
    return data;
  }
  function errorAt(host, error) {
    if (!host) return;
    let output = $('.gaminu-form-error', host);
    if (!output) { output = document.createElement('p'); output.className = 'gaminu-form-error'; output.setAttribute('role', 'alert'); host.append(output); }
    output.textContent = error?.message || t('Connection failed. Please try again.', 'Ryšio klaida. Bandykite dar kartą.');
  }

  // Inventory is rendered by Liquid for the current cart and by every GAMINU add-to-cart form.
  // Shopify remains the source of truth; these values are used to keep the storefront controls
  // in sync with the stock limits before a request reaches checkout.
  let initialInventory = [];
  try { initialInventory = JSON.parse($('#gaminuInventoryData')?.textContent || '[]'); } catch { initialInventory = []; }
  const inventoryByVariant = new Map();
  const finiteNumber = value => {
    if (value === '' || value == null) return null;
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  };
  function rememberInventory(id, data = {}) {
    id = Number(id);
    if (!id) return null;
    const previous = inventoryByVariant.get(id) || {};
    const stock = finiteNumber(data.stock ?? previous.stock);
    const limit = finiteNumber(data.limit ?? previous.limit);
    const meta = {
      id,
      tracked: data.tracked ?? previous.tracked ?? false,
      stock: stock == null ? 0 : Math.max(0, stock),
      limit: limit == null ? null : Math.max(0, limit),
      isPrinter: data.isPrinter ?? previous.isPrinter ?? false,
      sellable: data.sellable ?? previous.sellable ?? true
    };
    inventoryByVariant.set(id, meta);
    return meta;
  }
  initialInventory.forEach(item => rememberInventory(item.id, item));
  function inventoryFromForm(form) {
    if (!form) return null;
    const formData = new FormData(form);
    const id = Number(formData.get('id') || form.dataset.variantId);
    if (!id) return null;
    return rememberInventory(id, {
      isPrinter: form.dataset.isPrinter === 'true',
      tracked: form.dataset.stockTracked === 'true',
      stock: finiteNumber(form.dataset.stockCount),
      limit: finiteNumber(form.dataset.stockLimit),
      sellable: form.dataset.sellable !== 'false'
    });
  }
  function inventoryFromRow(row) {
    if (!row) return null;
    return rememberInventory(row.dataset.variantId, {
      isPrinter: row.dataset.isPrinter === 'true',
      tracked: row.dataset.stockTracked === 'true',
      stock: finiteNumber(row.dataset.stockCount),
      limit: finiteNumber(row.dataset.stockLimit),
      sellable: row.dataset.isPrinter === 'true' ? true : row.dataset.stockTracked === 'true' ? Number(row.dataset.stockCount || 0) > 0 : true
    });
  }
  $$('[data-gaminu-cart-form]').forEach(inventoryFromForm);
  $$('[data-line-key][data-variant-id]').forEach(inventoryFromRow);

  const variantQuantityInCart = (cart, variantId) => cart?.items?.reduce((total, item) => total + (Number(item.variant_id) === Number(variantId) ? Number(item.quantity || 0) : 0), 0) || 0;
  const stockSummary = meta => {
    if (meta?.isPrinter && meta.stock <= 0) return t('Delivery in 4–7 business days', 'Pristatymas per 4–7 d. d.');
    if (meta?.sellable === false || (meta?.tracked && !meta.isPrinter && meta.stock <= 0)) return meta.isPrinter ? t('Delivery in 4–7 business days', 'Pristatymas per 4–7 d. d.') : t('Out of stock', 'Išparduota');
    return t('In stock', 'Sandėlyje');
  };
  const stockCartSummary = (meta, cart) => {
    if (meta?.isPrinter && meta.stock <= 0) return t('Delivery in 4–7 business days', 'Pristatymas per 4–7 d. d.');
    if (!meta?.tracked) return '';
    if (meta.stock <= 0) return t('Out of stock. Reduce the quantity or remove this item.', 'Išparduota. Sumažinkite kiekį arba pašalinkite prekę.');
    const inCart = variantQuantityInCart(cart, meta.id);
    const remaining = meta.limit == null ? null : Math.max(0, meta.limit - inCart);
    if (remaining === 0) return t('Maximum quantity is already in your cart.', 'Maksimalus galimas kiekis jau yra jūsų krepšelyje.');
    return t('In stock', 'Sandėlyje');
  };
  const stockLimitError = (meta, remaining = 0) => {
    if (meta?.tracked && !meta.isPrinter && meta.stock <= 0) return new Error(t('This product is out of stock. Please wait for a restock or call +37066210651.', 'Šios prekės nėra sandėlyje. Palaukite papildymo arba skambinkite +37066210651.'));
    if (remaining <= 0) return new Error(t('The maximum available quantity is already in your cart.', 'Maksimalus galimas kiekis jau yra jūsų krepšelyje.'));
    return new Error(t('The requested quantity exceeds the available stock.', 'Pasirinktas kiekis viršija turimą likutį.'));
  };

  let currentCart = null;
  function syncProductStockUi(form, cart = currentCart) {
    if (!form) return;
    const meta = inventoryFromForm(form);
    if (!meta) return;
    const quantityInput = $('input[name="quantity"]', form);
    const submit = $('button[type=submit]', form);
    const minus = $('[data-qty-minus]', form);
    const plus = $('[data-qty-plus]', form);
    const min = Math.max(1, Number(quantityInput?.min || 1));
    const inCart = cart ? variantQuantityInCart(cart, meta.id) : 0;
    const remaining = meta.limit == null ? null : Math.max(0, meta.limit - inCart);
    const soldOut = meta.sellable === false || (meta.tracked && !meta.isPrinter && meta.stock <= 0);
    const blockedByCart = !soldOut && remaining != null && remaining < min;

    if (quantityInput) {
      if (remaining != null) quantityInput.max = String(remaining);
      else quantityInput.removeAttribute('max');
      quantityInput.disabled = soldOut || blockedByCart;
      if (!quantityInput.disabled && Number(quantityInput.value || min) > Number(quantityInput.max || Infinity)) quantityInput.value = String(Math.max(min, Number(quantityInput.max || min)));
      if (!quantityInput.disabled && Number(quantityInput.value || 0) < min) quantityInput.value = String(min);
    }
    if (minus) minus.disabled = soldOut || blockedByCart;
    if (plus) plus.disabled = soldOut || blockedByCart || (quantityInput && remaining != null && Number(quantityInput.value || min) >= remaining);
    if (submit) {
      submit.disabled = soldOut || blockedByCart;
      // A genuine out-of-stock selection offers a contact request instead of a dead cart button.
      if (form.classList.contains('product-form-main')) submit.hidden = soldOut;
      submit.dataset.stockDisabled = submit.disabled ? 'true' : 'false';
      const label = $('[data-add-label]', submit);
      if (label) label.textContent = soldOut ? (meta.isPrinter ? t('Delivery in 4–7 business days', 'Pristatymas per 4–7 d. d.') : t('OUT OF STOCK','IŠPARDUOTA')) : blockedByCart ? t('MAX IN CART','MAKS. KREPŠELYJE') : t('ADD TO CART','Į KREPŠELĮ');
    }

    if (form.classList.contains('product-form-main')) {
      const restockLink = $('#gaminuRestockLink');
      if (restockLink) restockLink.hidden = !soldOut;
      const buyRow = $('.buy-row', form);
      if (buyRow) buyRow.dataset.restockActive = String(soldOut);
      const status = $('#gaminuStock');
      if (status) status.innerHTML = `<span class="stock-dot${soldOut || (meta.isPrinter && meta.stock <= 0) ? ' out' : ''}"></span><span data-stock-text>${escape(stockSummary({...meta, sellable:!soldOut}))}</span>`;
      const restock = $('#gaminuRestockMessage');
      if (restock) restock.hidden = !soldOut;
      const cartNote = $('#gaminuCartLimitNote');
      if (cartNote) {
        if (!soldOut && remaining != null && cart && inCart > 0) {
          cartNote.hidden = false;
          cartNote.textContent = remaining > 0
            ? t('This product is already in your cart. You can add more while stock is available.', 'Ši prekė jau yra jūsų krepšelyje. Galite pridėti daugiau, kol yra sandėlyje.')
            : t('The maximum available quantity is already in your cart.', 'Maksimalus galimas kiekis jau yra jūsų krepšelyje.');
        } else {
          cartNote.hidden = true;
          cartNote.textContent = '';
        }
      }
    }
  }
  function syncStockLimitedForms(cart) {
    $$('[data-gaminu-cart-form]').forEach(form => syncProductStockUi(form, cart));
  }

  function renderCart(cart) {
    currentCart = cart;
    config.currency = cart.currency || config.currency;
    if ($('#gaminuCartCount')) $('#gaminuCartCount').textContent = cart.item_count;
    if ($('#gaminuDrawerTotal')) $('#gaminuDrawerTotal').textContent = money(cart.total_price);
    const body = $('#gaminuDrawerBody');
    if (body) {
      body.innerHTML = cart.items.length ? cart.items.map(item => {
        const meta = inventoryByVariant.get(Number(item.variant_id));
        const totalForVariant = variantQuantityInCart(cart, item.variant_id);
        const otherLines = Math.max(0, totalForVariant - Number(item.quantity || 0));
        const lineMax = meta?.limit == null ? null : Math.max(0, meta.limit - otherLines);
        const plusBlocked = lineMax != null && Number(item.quantity || 0) >= lineMax;
        const stockNote = meta?.tracked ? `<small class="drawer-stock-note${meta.stock <= 0 ? ' out' : ''}">${escape(stockCartSummary(meta, cart))}</small>` : '';
        return `<div class="gaminu-drawer-item" data-drawer-variant-id="${Number(item.variant_id)}">${item.image ? `<img src="${escape(item.image)}" alt="">` : '<span></span>'}<div><a href="${escape(item.url)}"><strong>${escape(item.product_title)}</strong></a><small>${escape(item.variant_title === 'Default Title' ? '' : item.variant_title)}</small>${stockNote}<div>${item.quantity} × ${money(item.final_price)}</div><div class="cart-line-qty"><button type="button" data-cart-key="${escape(item.key)}" data-cart-variant-id="${Number(item.variant_id)}" data-cart-quantity="${item.quantity-1}" aria-label="${t('Decrease quantity','Mažinti kiekį')}">−</button><span>${item.quantity}</span><button type="button" data-cart-key="${escape(item.key)}" data-cart-variant-id="${Number(item.variant_id)}" data-cart-quantity="${item.quantity+1}"${lineMax == null ? '' : ` data-cart-max="${lineMax}"`}${plusBlocked ? ' data-stock-disabled="true" disabled' : ''} aria-label="${t('Increase quantity','Didinti kiekį')}">+</button><button type="button" data-cart-key="${escape(item.key)}" data-cart-variant-id="${Number(item.variant_id)}" data-cart-quantity="0" aria-label="${t('Remove','Pašalinti')}">×</button></div></div><strong>${money(item.final_line_price)}</strong></div>`;
      }).join('') : `<p class="cart-empty">${t('Your cart is empty.', 'Krepšelis tuščias.')}</p>`;
    }
    syncStockLimitedForms(cart);
  }
  async function refreshCart() {
    if (cartPage && !(await savePageQuantities())) return;
    const cart = await api('cart.js', {cache:'no-store'});
    renderCart(cart);
    syncCartPage(cart);
  }
  $('#gaminuCartOpen')?.addEventListener('click', async () => {
    setPanel(drawer, drawerBg, true);
    try { await refreshCart(); } catch(error) { errorAt($('#gaminuDrawerBody'), error); }
  });

  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-gaminu-cart-form]');
    if (!form) return;
    e.preventDefault();
    const button = $('button[type=submit]', form);
    if (button?.disabled) return;
    $('.gaminu-form-error', form)?.remove();
    if (button) button.disabled = true;

    try {
      const meta = inventoryFromForm(form);
      const formData = new FormData(form);
      const variantId = Number(formData.get('id') || form.dataset.variantId);
      const desired = Math.max(1, Number(formData.get('quantity') || 1));
      if (meta?.sellable === false || (meta?.tracked && !meta.isPrinter && meta.stock <= 0)) throw stockLimitError(meta, 0);

      if (meta?.limit != null) {
        const cartBefore = await api('cart.js', {cache:'no-store'});
        currentCart = cartBefore;
        const alreadyInCart = variantQuantityInCart(cartBefore, variantId);
        const remaining = Math.max(0, meta.limit - alreadyInCart);
        if (desired > remaining) throw stockLimitError(meta, remaining);
      }

      await api('cart/add.js', {method:'POST', body:formData});
      setPanel(drawer, drawerBg, true);
      await refreshCart();
    } catch(error) {
      try {
        const cart = await api('cart.js', {cache:'no-store'});
        renderCart(cart);
        syncCartPage(cart);
      } catch { /* Keep the original error if the refresh also fails. */ }
      errorAt(form, error);
    } finally {
      if (button) {
        const meta = inventoryFromForm(form);
        const min = Math.max(1, Number($('input[name="quantity"]', form)?.min || 1));
        const remaining = meta?.limit == null || !currentCart ? null : Math.max(0, meta.limit - variantQuantityInCart(currentCart, meta.id));
        button.disabled = meta?.sellable === false || (meta?.tracked && !meta.isPrinter && meta.stock <= 0) || (remaining != null && remaining < min);
      }
    }
  });

  $('#gaminuDrawerBody')?.addEventListener('click', async e => {
    const button = e.target.closest('[data-cart-key]');
    if (!button || cartBusy || button.disabled) return;
    const change = {id:button.dataset.cartKey, quantity:Number(button.dataset.cartQuantity)};
    const max = finiteNumber(button.dataset.cartMax);
    if (max != null && change.quantity > max) {
      errorAt($('#gaminuDrawerBody'), stockLimitError(inventoryByVariant.get(Number(button.dataset.cartVariantId)), 0));
      return;
    }
    if (cartPage && !(await savePageQuantities())) return;
    setCartBusy(true);
    cartTask = (async () => {
      try {
        const cart = await api('cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(change)});
        renderCart(cart); syncCartPage(cart);
        const actual = cart.items.find(item => item.key === change.id)?.quantity || 0;
        if (actual !== change.quantity) throw new Error(t('The requested quantity is unavailable.', 'Pageidaujamo kiekio nėra.'));
        return true;
      } catch(error) {
        try { const cart = await api('cart.js', {cache:'no-store'}); renderCart(cart); syncCartPage(cart); } catch { /* Keep the last confirmed cart and show the error. */ }
        errorAt($('#gaminuDrawerBody'), error); return false;
      } finally { setCartBusy(false); }
    })();
    await cartTask;
  });

  // One server-confirmed cart for page, drawer and checkout; never replace app widgets.
  const cartPage = $('[data-gaminu-cart-page]');
  if (cartPage) $$('[data-cart-input]', cartPage).forEach(input => input.dataset.savedQuantity = input.value);
  let cartBusy = false, quantityTimer;
  let cartTask = Promise.resolve(true);

  // Business invoice details are regular Shopify cart attributes, not checkout form fields.
  // Save only our business keys: never overwrite Parcely's own cart attributes.
  const companyCard = cartPage ? $('[data-gaminu-company]', cartPage) : null;
  const companyToggle = companyCard ? $('[data-company-toggle]', companyCard) : null;
  const companyFields = companyCard ? $('[data-company-fields]', companyCard) : null;
  const companyCode = companyCard ? $('[data-company-code]', companyCard) : null;
  const companyError = companyCard ? $('[data-company-error]', companyCard) : null;
  const companyRetry = companyCard ? $('[data-company-retry]', companyCard) : null;
  const companyCheckout = cartPage ? $('[data-gaminu-checkout-button]', cartPage) : null;
  let companyChangeVersion = 0;
  let companySavedVersion = 0;
  let companySaveRunning = false;
  let companySaveTimer = 0;
  let companySavePromise = Promise.resolve(true);

  function showCompanyFields() {
    if (!companyToggle) return;
    const enabled = companyToggle.checked;
    companyFields.hidden = !enabled;
    companyCard.classList.toggle('is-active', enabled);
    companyCode.disabled = !enabled;
    companyCode.required = enabled;
  }

  function companyAttributeValues() {
    return {
      'Buy as a company': companyToggle.checked ? 'Yes' : 'No',
      'Company name': '', // Clear any legacy value; the name is entered in checkout.
      'Company code': companyToggle.checked ? companyCode.value.trim() : ''
    };
  }

  async function saveCompanyAttributes() {
    clearTimeout(companySaveTimer);
    if (!companyCard) return true;
    if (companySaveRunning) return companySavePromise;
    if (companySavedVersion === companyChangeVersion) return true;

    companySaveRunning = true;
    companySavePromise = (async () => {
      try {
        // Coalesce rapid edits, but always write the latest state after an in-flight request.
        while (companySavedVersion < companyChangeVersion) {
          const version = companyChangeVersion;
          const attributes = companyAttributeValues();
          await api('cart/update.js', {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({attributes})
          });
          companySavedVersion = version;
        }
        companyError.textContent = '';
        companyRetry.hidden = true;
        return true;
      } catch (error) {
        companyError.textContent = error?.message || t('Could not save company details. Try again.', 'Nepavyko išsaugoti įmonės duomenų. Bandykite dar kartą.');
        companyRetry.hidden = false;
        return false;
      } finally {
        companySaveRunning = false;
        if (companyCheckout) companyCheckout.disabled = companySavedVersion < companyChangeVersion;
      }
    })();
    return companySavePromise;
  }

  function companyFieldsChanged(immediate = false) {
    companyChangeVersion += 1;
    companyError.textContent = '';
    companyRetry.hidden = true;
    if (companyCheckout) companyCheckout.disabled = true;
    clearTimeout(companySaveTimer);
    companySaveTimer = window.setTimeout(saveCompanyAttributes, immediate ? 0 : 450);
  }

  if (companyCard) {
    showCompanyFields();
    companyToggle.addEventListener('change', () => {
      showCompanyFields();
      companyFieldsChanged(true); // Clearing the checkbox also clears its stored company values.
    });
    companyCode.addEventListener('input', () => companyFieldsChanged());
    companyCode.addEventListener('change', () => companyFieldsChanged(true));
    // Remove values recorded by the previous cart form even if the buyer changes nothing.
    if (companyCard.dataset.companyLegacyName === 'true') companyFieldsChanged(true);
    companyRetry.addEventListener('click', saveCompanyAttributes);

    // Checkout submits are handled in one place below; never race cart attributes
    // with the Parcely checkout-delay app or the native checkout redirect.
  }

  function syncCartPage(cart) {
    if (!cartPage) return;
    const rows = $$('[data-line-key]', cartPage);
    const keys = new Set(rows.map(row => row.dataset.lineKey));
    if (cart.items.some(item => !keys.has(item.key)) || !cart.items.length) {
      location.reload(); return;
    }
    rows.forEach(row => {
      const item = cart.items.find(item => item.key === row.dataset.lineKey);
      if (!item) { row.remove(); return; }
      const meta = inventoryFromRow(row) || inventoryByVariant.get(Number(item.variant_id));
      const input = $('[data-cart-input]', row);
      input.value = item.quantity;
      input.dataset.savedQuantity = String(item.quantity);
      if (meta?.limit != null) {
        const totalForVariant = variantQuantityInCart(cart, item.variant_id);
        const otherLines = Math.max(0, totalForVariant - Number(item.quantity || 0));
        input.max = String(Math.max(0, meta.limit - otherLines));
      } else input.removeAttribute('max');
      const stockNote = $('[data-cart-stock-note]', row);
      if (stockNote) {
        stockNote.textContent = stockCartSummary(meta, cart);
        stockNote.classList.toggle('out', !!meta?.tracked && !meta.isPrinter && meta.stock <= 0);
        stockNote.hidden = !meta?.tracked;
      }
      $('[data-line-total]', row).textContent = money(item.final_line_price);
    });
    updateCartDeliveryEstimate(cart);
    syncStockLimitedForms(cart);
  }
  function setCartBusy(busy) {
    cartBusy = busy;
    cartPage?.setAttribute('aria-busy', String(busy));
    $$('[data-cart-input]').forEach(el => el.disabled = busy);
    $$('#gaminuDrawerBody button').forEach(el => {
      el.disabled = busy || el.dataset.stockDisabled === 'true';
    });
  }
  function savePageQuantities() {
    clearTimeout(quantityTimer);
    if (!cartPage) return cartTask;
    if (cartBusy) return cartTask;
    if ($$('[data-cart-input]', cartPage).some(input => !input.reportValidity())) return Promise.resolve(false);
    const changes = $$('[data-cart-input]', cartPage).filter(input => input.value !== input.dataset.savedQuantity).map(input => ({
      id: input.closest('[data-line-key]').dataset.lineKey,
      quantity: Number(input.value)
    }));
    setCartBusy(true);
    cartTask = (async () => {
      try {
        let cart = await api('cart.js', {cache:'no-store'});
        for (const change of changes) {
          const current = cart.items.find(item => item.key === change.id);
          if (!current) throw new Error(t('Your cart changed. Review it and try again.', 'Krepšelis pasikeitė. Patikrinkite ir bandykite dar kartą.'));
          const row = $(`[data-line-key="${CSS.escape(change.id)}"]`, cartPage);
          const meta = inventoryFromRow(row) || inventoryByVariant.get(Number(current.variant_id));
          if (meta?.limit != null) {
            const totalForVariant = variantQuantityInCart(cart, current.variant_id);
            const otherLines = Math.max(0, totalForVariant - Number(current.quantity || 0));
            const lineMax = Math.max(0, meta.limit - otherLines);
            if (change.quantity > lineMax) throw stockLimitError(meta, Math.max(0, lineMax - Number(current.quantity || 0)));
          }
          if (current.quantity !== change.quantity) {
            cart = await api('cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(change)});
            const actual = cart.items.find(item => item.key === change.id)?.quantity || 0;
            if (actual !== change.quantity) throw new Error(t('The requested quantity is unavailable. Your cart shows the available quantity.', 'Pageidaujamo kiekio nėra. Krepšelyje rodomas galimas kiekis.'));
          }
        }
        renderCart(cart); syncCartPage(cart);
        $('.gaminu-form-error', cartPage).textContent = '';
        return true;
      } catch (error) {
        try { const cart = await api('cart.js', {cache:'no-store'}); renderCart(cart); syncCartPage(cart); } catch { /* Retain visible inputs and the original actionable error. */ }
        errorAt(cartPage, error); return false;
      } finally { setCartBusy(false); }
    })();
    return cartTask;
  }
  cartPage?.addEventListener('input', e => {
    if (!e.target.matches('[data-cart-input]')) return;
    clearTimeout(quantityTimer); quantityTimer = setTimeout(savePageQuantities, 550);
  });
  cartPage?.addEventListener('change', e => {
    if (e.target.matches('[data-cart-input]')) savePageQuantities();
  });
  // Shopify determines real checkout shipping/taxes. These figures are marked as estimates;
  // the existing Parcely widget stays the only selector of its underlying delivery method.
  const shippingEstimate = $('[data-gaminu-shipping-estimate]', cartPage || document);
  // Liquid marks individual restricted line items, and the CSV adds Parcely's
  // documented hide-parcely tag on printer products for checkout/app compatibility.
  // Cart Ajax is the source of truth; update after each confirmed quantity change.
  function cartHasLockerRestriction(cart = currentCart) {
    if (!cartPage) return false;
    if (!cart?.items) return cartPage.dataset.lockerRestricted === 'true';
    // Keys can change after discounts or other cart updates. Product IDs remain stable.
    const restrictedRows = $$('[data-line-key][data-locker-restricted="true"]', cartPage);
    const restrictedKeys = new Set(restrictedRows.map(row => row.dataset.lineKey));
    const restrictedProducts = new Set(restrictedRows.map(row => Number(row.dataset.productId)));
    const restrictedVariants = new Set(restrictedRows.map(row => Number(row.dataset.variantId)));
    return cart.items.some(item => Number(item.quantity) > 0 && (
      restrictedKeys.has(item.key) ||
      restrictedProducts.has(Number(item.product_id)) ||
      restrictedVariants.has(Number(item.variant_id)) ||
      /^(?:3d\s*)?printers?$/i.test(String(item.product_type || '').trim()) ||
      /^3d\s+(?:spausdintuvas|printer)\s*(?:-|$)/i.test(item.product_title || '') ||
      /\s3d printer\s*\(/i.test(item.product_title || '')
    ));
  }
  const shippingEstimateSettings = shippingEstimate ? {
    lockerPrice: Math.max(0, Number(shippingEstimate.dataset.lockerPriceCents || 480)),
    freeFrom: Math.max(0, Number(shippingEstimate.dataset.freeShippingFromCents || 3900))
  } : null;
  function updateCartDeliveryEstimate(cart = currentCart) {
    if (!shippingEstimate || !shippingEstimateSettings) return;
    // On a fresh cart page currentCart is still null until /cart.js responds.
    // The Liquid-rendered item subtotal is already reliable, so clicking LP EXPRESS
    // must update the visible estimate immediately, even before that response.
    const products = Math.max(0, Number((cart || currentCart)?.total_price ?? shippingEstimate.dataset.productsTotalCents ?? 0));
    const lockerRestricted = cartHasLockerRestriction(cart);
    cartPage.dataset.lockerRestricted = String(lockerRestricted);
    if (lockerToggle) {
      lockerToggle.disabled = lockerRestricted;
      lockerToggle.setAttribute('aria-disabled', String(lockerRestricted));
      const usual = $('[data-locker-usual-note]', lockerToggle);
      const blocked = $('[data-locker-blocked-note]', lockerToggle);
      if (usual) usual.hidden = lockerRestricted;
      if (blocked) blocked.hidden = !lockerRestricted;
    }
    const restrictionNote = $('[data-locker-restriction-note]', cartPage);
    if (restrictionNote) restrictionNote.hidden = !lockerRestricted;
    // Never retain a previous locker selection after a printer is added to the cart.
    if (lockerRestricted && deliveryMode === 'locker') {
      setDeliveryMode('shipping');
      return;
    }
    const freeShipping = !lockerRestricted && products >= shippingEstimateSettings.freeFrom;
    const lockerPrice = freeShipping ? 0 : shippingEstimateSettings.lockerPrice;
    const lockerSelected = !lockerRestricted && deliveryMode === 'locker';
    const label = $('[data-cart-total-label]', shippingEstimate);
    const locker = $('[data-locker-price-note]', deliveryChoice);
    const goal = cartPage ? $('[data-gaminu-shipping-goal]', cartPage) : null;

    $('[data-cart-products-total]', shippingEstimate).textContent = money(products);
    if (locker) locker.textContent = lockerPrice ? money(lockerPrice) : t('FREE', 'Nemokamai');
    if (lockerSelected) {
      // The cart shows the indicative locker fee only; the real rate remains controlled by Parcely.
      label.textContent = t('Estimated total', 'Preliminari suma');
      $('[data-cart-total]', shippingEstimate).textContent = money(products + lockerPrice);
    } else {
      // Pickup is free; DPD courier has its own paid rate (never free from the locker threshold).
      label.textContent = t('Estimated total from', 'Preliminari suma nuo');
      $('[data-cart-total]', shippingEstimate).textContent = money(products);
    }
    if (goal) {
      goal.hidden = lockerRestricted;
      const remaining = Math.max(0, shippingEstimateSettings.freeFrom - products);
      const pending = $('[data-goal-pending]', goal);
      const unlocked = $('[data-goal-unlocked]', goal);
      const amount = $('[data-goal-remaining]', goal);
      const progress = $('[data-goal-progress]', goal);
      const bar = $('[data-goal-bar]', goal);
      if (amount) amount.textContent = money(remaining);
      if (pending) pending.hidden = remaining === 0;
      if (unlocked) unlocked.hidden = remaining !== 0;
      const goalValue = shippingEstimateSettings.freeFrom > 0
        ? Math.min(products, shippingEstimateSettings.freeFrom) : 0;
      if (progress) progress.setAttribute('aria-valuenow', String(goalValue));
      if (bar) bar.style.width = shippingEstimateSettings.freeFrom > 0
        ? `${Math.min(100, Math.max(0, products / shippingEstimateSettings.freeFrom * 100))}%` : '0%';
    }
  }
  // GAMINU delivery flow.
  // Parcely remains the single source of truth for the shipping method. The custom GAMINU
  // cards only select the corresponding Parcely method and control the presentation.
  // This is important because Parcely's checkout-delay embed validates its own selected
  // method before Shopify checkout is opened.
  const deliveryChoice = $('[data-gaminu-delivery-choice]');
  const deliveryButtons = deliveryChoice ? $$('[data-delivery-mode]', deliveryChoice) : [];
  const lockerToggle = deliveryChoice ? $('[data-delivery-mode="locker"]', deliveryChoice) : null;
  const shippingToggle = deliveryChoice ? $('[data-delivery-mode="shipping"]', deliveryChoice) : null;
  const deliveryGuidance = deliveryChoice ? $('[data-delivery-guidance]', deliveryChoice) : null;
  const parcelySlot = deliveryChoice ? $('[data-gaminu-parcely-slot]', deliveryChoice) : null;
  const parcelyWidget = $('#parcelyWidget');
  const parcelyLoading = deliveryChoice ? $('[data-parcely-loading]', deliveryChoice) : null;
  let deliveryMode = 'shipping';
  let deliveryModeChangedByCustomer = false;
  let parcelyMutationFrame = 0;
  let parcelyRetryTimer = 0;

  const normalizeText = value => String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();

  const parcelyLocationSelected = cart => {
    const attributes = cart?.attributes || {};
    return Object.entries(attributes).some(([key, value]) => {
      const normalized = key.toLowerCase();
      return (normalized === 'location_name' || normalized.includes('pickup_point') || normalized.includes('parcel_locker')) && String(value || '').trim();
    });
  };

  function setDeliveryGuidance(message = '', state = '') {
    if (!deliveryGuidance) return;
    deliveryGuidance.hidden = !message;
    deliveryGuidance.textContent = message;
    deliveryGuidance.classList.toggle('is-error', state === 'error');
    deliveryGuidance.classList.toggle('is-success', state === 'success');
  }

  function getParcelyMethodItems() {
    if (!parcelyWidget) return [];

    const documentedItems = $$('.prs-cart__delivery-item,.prs-cart__banner-item', parcelyWidget);
    if (documentedItems.length) return documentedItems;

    const seen = new Set();
    return $$('input[type="radio"]', parcelyWidget).map(input => {
      let row = input.closest('label,[role="radio"],[class*="delivery-item"],[class*="banner-item"]');
      if (!row) row = input.parentElement;
      while (row && row !== parcelyWidget && normalizeText(row.textContent).length < 8) row = row.parentElement;
      return row && row !== parcelyWidget ? row : null;
    }).filter(row => row && !seen.has(row) && seen.add(row));
  }

  function parcelyItemText(item) {
    const input = item?.querySelector('input[type="radio"],input[type="checkbox"]');
    return normalizeText(`${item?.textContent || ''} ${input?.value || ''} ${input?.getAttribute('aria-label') || ''}`);
  }

  function isLockerMethod(item) {
    const haystack = parcelyItemText(item);
    const locker = /(lp\s*express|parcel\s*locker|locker|paštomat|pick[\s-]?up point|atsiėmimo punkt)/i.test(haystack);
    const storePickup = /(laisvės|atsiimsiu prekes vietoje|atsiėmimas gaminu|store pick[\s-]?up|pickup in store)/i.test(haystack);
    return locker && !storePickup;
  }

  function isCourierMethod(item) {
    const haystack = parcelyItemText(item);
    const courier = /(courier|kurjer|dpd|home delivery|delivery by courier|pristatymas.*kurjer)/i.test(haystack);
    const excluded = /(lp\s*express|parcel\s*locker|locker|paštomat|pick[\s-]?up point|atsiėmimo punkt|laisvės|atsiimsiu prekes vietoje|store pick[\s-]?up|pickup in store)/i.test(haystack);
    return courier && !excluded;
  }

  function methodSelected(item) {
    if (!item) return false;
    const input = item.querySelector('input[type="radio"],input[type="checkbox"]');
    return !!(
      input?.checked ||
      item.classList.contains('active') ||
      item.getAttribute('aria-checked') === 'true' ||
      item.querySelector('[aria-checked="true"]')
    );
  }

  function revealParcelyMethods(items) {
    items.forEach(item => {
      item.classList.remove('gaminu-parcely-methods-hidden');
      item.removeAttribute('aria-hidden');
      const group = item.closest('.prs-cart__radios');
      group?.classList.remove('gaminu-parcely-methods-hidden');
      group?.removeAttribute('aria-hidden');
    });
  }

  function hideSelectedParcelyMethodGroup(selectedItem, items) {
    if (!selectedItem || !methodSelected(selectedItem)) return;
    const explicitGroup = selectedItem.closest('.prs-cart__radios');
    const commonParent = selectedItem.parentElement;
    const candidateGroup = explicitGroup || commonParent;
    const groupItems = candidateGroup ? items.filter(item => candidateGroup.contains(item)) : [];

    // Hide the duplicated Parcely method choices only after Parcely has actually marked one active.
    // The location/provider controls remain visible below for LP EXPRESS.
    if (candidateGroup && groupItems.length >= 2) {
      candidateGroup.classList.add('gaminu-parcely-methods-hidden');
      candidateGroup.setAttribute('aria-hidden', 'true');
    }
  }

  function activateParcelyMethod(item) {
    if (!item) return false;
    if (methodSelected(item)) return true;

    // Parcely binds its state to the delivery item itself. Clicking only the nested radio can
    // visually check it without updating Parcely's internal shipping-method state.
    item.click();

    if (methodSelected(item)) return true;

    // Fallback for markup variants where the click listener is attached to the input/label.
    const input = item.querySelector('input[type="radio"],input[type="checkbox"]');
    if (input) {
      input.click();
      if (!methodSelected(item)) {
        input.checked = true;
        input.dispatchEvent(new Event('input', {bubbles:true}));
        input.dispatchEvent(new Event('change', {bubbles:true}));
      }
    }

    return methodSelected(item);
  }

  function desiredParcelyMethod(items) {
    if (deliveryMode === 'locker') return items.find(isLockerMethod) || null;
    return items.find(isCourierMethod) || null;
  }

  function simplifyParcelyWidget() {
    if (!parcelyWidget || cartHasLockerRestriction()) return;

    const methodItems = getParcelyMethodItems();
    if (!methodItems.length) {
      if (parcelyLoading && deliveryMode === 'locker') parcelyLoading.hidden = false;
      return;
    }

    revealParcelyMethods(methodItems);
    const desired = desiredParcelyMethod(methodItems);
    const selected = desired ? activateParcelyMethod(desired) : false;

    if (selected) {
      hideSelectedParcelyMethodGroup(desired, methodItems);
      if (deliveryMode === 'shipping') setDeliveryGuidance('');
    } else if (deliveryMode === 'shipping') {
      // Do not silently send the customer to checkout with no Parcely method selected.
      // If a store configuration changes and no courier method can be identified, keep the
      // app choices available instead of creating an invalid checkout.
      setDeliveryGuidance(
        t('Choose the courier shipping method below before continuing.', 'Prieš tęsdami pasirinkite pristatymą kurjeriu.'),
        'error'
      );
    }

    // Our wrapper already explains the step. Hide only the duplicated heading after a valid
    // method is selected; never hide the actual method choices when selection failed.
    $$('h1,h2,h3,h4,h5,strong,p,span,div', parcelyWidget).forEach(node => {
      if (node.children.length) return;
      const text = normalizeText(node.textContent);
      const duplicateHeading =
        text === 'please choose a shipping method' ||
        text === 'choose a shipping method' ||
        /^pasirinkite .*pristatymo.*būd/.test(text);
      node.classList.toggle('gaminu-parcely-heading-hidden', !!selected && duplicateHeading);
    });

    if (parcelyLoading) {
      const ready = !!parcelyWidget.querySelector('.prs-cart__delivery-item,.prs-cart__banner-item,select,input,[class*="prs-cart"]');
      parcelyLoading.hidden = deliveryMode !== 'locker' || ready;
    }
  }

  function scheduleParcelySimplify(delay = 0) {
    clearTimeout(parcelyRetryTimer);
    parcelyRetryTimer = window.setTimeout(() => {
      if (parcelyMutationFrame) cancelAnimationFrame(parcelyMutationFrame);
      parcelyMutationFrame = requestAnimationFrame(() => {
        parcelyMutationFrame = 0;
        simplifyParcelyWidget();
      });
    }, delay);
  }

  if (parcelyWidget) {
    new MutationObserver(() => scheduleParcelySimplify()).observe(parcelyWidget, {
      childList:true,
      subtree:true,
      attributes:true,
      attributeFilter:['class','checked','aria-checked']
    });
  }

  function setDeliveryMode(mode) {
    // The locker selector must never be usable when a 3D printer is in the order.
    const allowLocker = !cartHasLockerRestriction();
    deliveryMode = mode === 'locker' && allowLocker ? 'locker' : 'shipping';
    const lockerActive = deliveryMode === 'locker';

    if (lockerToggle) {
      lockerToggle.classList.toggle('is-active', lockerActive);
      lockerToggle.setAttribute('aria-pressed', String(lockerActive));
      lockerToggle.setAttribute('aria-expanded', String(lockerActive));
    }
    if (shippingToggle) {
      shippingToggle.classList.toggle('is-active', !lockerActive);
      shippingToggle.setAttribute('aria-pressed', String(!lockerActive));
    }

    if (parcelySlot) parcelySlot.hidden = !lockerActive;

    if (lockerActive) {
      setDeliveryGuidance(
        t('Select your LP EXPRESS locker, then continue to checkout.', 'Pasirinkite LP EXPRESS paštomatą, tada tęskite į atsiskaitymą.')
      );
    } else {
      setDeliveryGuidance('');
    }

    // Update estimated shipping as soon as the user changes the delivery card.
    updateCartDeliveryEstimate(currentCart);

    // Parcely is loaded after the theme. Retry at the points where its widget normally appears.
    scheduleParcelySimplify(0);
    window.setTimeout(() => scheduleParcelySimplify(), 180);
    window.setTimeout(() => scheduleParcelySimplify(), 650);
    window.setTimeout(() => scheduleParcelySimplify(), 1600);
  }

  // A courier / store-pickup request is NOT a Parcely parcel-locker request.
  // Use Shopify's normal checkout route so Parcely's delayed "choose shipping method"
  // validator cannot block a cart that intentionally has no locker widget (hide-parcely).
  // The LP EXPRESS path still uses Parcely's own handler and location validation.
  let checkoutIsProcessing = false;
  let checkoutNavigationStarted = false;
  let allowParcelyFormSubmit = false;
  const isNativeDelivery = () => deliveryMode !== 'locker' || cartHasLockerRestriction();

  async function continueWithNativeDelivery() {
    if (!cartPage || checkoutIsProcessing || checkoutNavigationStarted) return;
    checkoutIsProcessing = true;
    if (companyCheckout) companyCheckout.disabled = true;
    try {
      clearTimeout(quantityTimer);
      // All pending quantity and business-info updates must be persisted first.
      if (!(await cartTask)) return;
      const dirtyQuantities = $$('[data-cart-input]', cartPage)
        .some(input => input.value !== input.dataset.savedQuantity);
      if (dirtyQuantities && !(await savePageQuantities())) return;
      if (!(await saveCompanyAttributes())) return;

      const freshCart = await api('cart.js', {cache:'no-store'});
      if (!freshCart.items?.length) {
        throw new Error(t('Your cart is empty. Please add a product first.', 'Krepšelis tuščias. Pirmiausia pridėkite prekę.'));
      }
      // Another tab may have changed the cart. Reload the Liquid restriction data,
      // including product tags and category, before allowing a new checkout choice.
      const renderedRows = $$('[data-line-key]', cartPage);
      const rowKeys = new Set(renderedRows.map(row => row.dataset.lineKey));
      const renderedProductIds = new Set(renderedRows.map(row => Number(row.dataset.productId)));
      // Shopify may change line keys when a discount is applied; the stable product
      // ID avoids needless reloads. Only truly new, unclassified products require one.
      if (freshCart.items.some(item => !rowKeys.has(item.key)
        && !renderedProductIds.has(Number(item.product_id)))) {
        location.reload();
        return;
      }
      currentCart = freshCart;
      updateCartDeliveryEstimate(freshCart);
      const restricted = cartHasLockerRestriction(freshCart);
      if (restricted) setDeliveryMode('shipping');
      if (!restricted && deliveryMode === 'locker') {
        setDeliveryGuidance(t('Please select a locker before continuing.', 'Prieš tęsdami pasirinkite paštomatą.'), 'error');
        return;
      }

      // Clear only stale, identifiable locker-location attributes. Do not replace
      // unrelated cart attributes (company, customer instructions, etc.).
      const staleLockerKeys = Object.keys(freshCart.attributes || {}).filter(key =>
        /(?:^location_name$|pickup_point|parcel_locker)/i.test(key)
      );
      if (staleLockerKeys.length) {
        const attributes = Object.fromEntries(staleLockerKeys.map(key => [key, '']));
        await api('cart/update.js', {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({attributes})
        });
      }
      // Shopify calculates real delivery options at checkout. This direct route
      // bypasses Parcely's *client-side* locker selector, NOT Shopify shipping rules.
      checkoutNavigationStarted = true;
      window.location.assign(root + 'checkout');
    } catch (error) {
      errorAt(cartPage, error);
    } finally {
      checkoutIsProcessing = false;
      if (companyCheckout && !checkoutNavigationStarted)
        companyCheckout.disabled = companySavedVersion < companyChangeVersion;
    }
  }

  // Capture before Parcely's delegated click listener runs on document/body.
  document.addEventListener('click', event => {
    const checkoutButton = event.target.closest?.('[data-gaminu-checkout-button]');
    if (!checkoutButton || !cartPage?.contains(checkoutButton) || !isNativeDelivery()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (cartPage.reportValidity()) continueWithNativeDelivery();
  }, true);

  // Also handles pressing Enter in the form, custom submit buttons, and unsaved
  // company data. Keep the native Parcely submit hook for actual locker selections.
  cartPage?.addEventListener('submit', async event => {
    if (event.submitter && event.submitter.name !== 'checkout') return;
    if (!isNativeDelivery()) {
      if (allowParcelyFormSubmit) { allowParcelyFormSubmit = false; return; }
      if (companySavedVersion === companyChangeVersion && !$$('[data-cart-input]', cartPage)
        .some(input => input.value !== input.dataset.savedQuantity)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (checkoutIsProcessing) return;
      checkoutIsProcessing = true;
      try {
        clearTimeout(quantityTimer);
        if (!(await cartTask)) return;
        if ($$('[data-cart-input]', cartPage).some(input => input.value !== input.dataset.savedQuantity)
          && !(await savePageQuantities())) return;
        if (!(await saveCompanyAttributes())) return;
        const freshCart = await api('cart.js', {cache:'no-store'});
        currentCart = freshCart;
        updateCartDeliveryEstimate(freshCart);
        if (cartHasLockerRestriction(freshCart)) {
          // A printer was added in another tab while the buyer had the locker mode
          // selected: switch to Shopify's native courier/pickup checkout immediately.
          setDeliveryMode('shipping');
          checkoutIsProcessing = false;
          await continueWithNativeDelivery();
          return;
        }
        allowParcelyFormSubmit = true;
        cartPage.requestSubmit(event.submitter || companyCheckout);
      } catch (error) { errorAt(cartPage, error); }
      finally { checkoutIsProcessing = false; }
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (cartPage.reportValidity()) continueWithNativeDelivery();
  }, true);

  deliveryButtons.forEach(button => button.addEventListener('click', () => {
    const nextMode = button.dataset.deliveryMode === 'locker' ? 'locker' : 'shipping';
    if (nextMode === 'locker' && cartHasLockerRestriction()) return;
    if (nextMode === deliveryMode) return;
    deliveryModeChangedByCustomer = true;
    setDeliveryMode(nextMode);
  }));

  if (deliveryChoice) {
    updateCartDeliveryEstimate();
    (async () => {
      let cart = null;
      try {
        cart = await api('cart.js', {cache:'no-store'});
        // Keep the confirmed Shopify cart available to the shipping estimator.
        // A quantity update may have completed while this first request ran;
        // in that case retain the more recent cart instead of overwriting it.
        if (!currentCart) currentCart = cart;
        config.currency = currentCart.currency || config.currency;
        updateCartDeliveryEstimate(currentCart);
      } catch { /* Continue using Liquid's initially rendered subtotal. */ }
      // Never undo a shopper's selection if they clicked before /cart.js returned.
      if (!deliveryModeChangedByCustomer) setDeliveryMode(parcelyLocationSelected(currentCart || cart) ? 'locker' : 'shipping');
    })();
  }

  window.addEventListener('pageshow', async e => {
    if (!e.persisted || cartBusy) return;
    try { const cart = await api('cart.js', {cache:'no-store'}); renderCart(cart); syncCartPage(cart); }
    catch(error) { if (cartPage) errorAt(cartPage, error); }
  });

  window.addEventListener('focus', async () => {
    if (cartBusy || !cartPage || $$('[data-cart-input]', cartPage).some(input => input.value !== input.dataset.savedQuantity)) return;
    try { const cart = await api('cart.js', {cache:'no-store'}); if (!cartBusy && !$$('[data-cart-input]', cartPage).some(input => input.value !== input.dataset.savedQuantity)) { renderCart(cart); syncCartPage(cart); } }
    catch(error) { errorAt(cartPage, error); }
  });

  // Fetch the current cart once on pages that can add products, so repeated clicks cannot
  // exceed the available inventory even before the cart drawer has been opened.
  if ($('[data-gaminu-cart-form]')) {
    api('cart.js', {cache:'no-store'}).then(cart => { renderCart(cart); syncCartPage(cart); }).catch(() => { /* Shopify validates again on add/change. */ });
  }

  // Group diameter aliases without changing Shopify's underlying filter values.
  const filterForm = $('#gaminuFilters');
  if (filterForm) {
    $$('.facet-values', filterForm).forEach(group => {
      if (group.closest('details').dataset.filterOperator === 'AND') return;
      const aliases = $$('input[type="checkbox"]', group).filter(input => /^1[.,]75\s*(mm)?$/i.test(input.value.trim()));
      if (!aliases.length) return;
      const first = aliases[0];
      first.dataset.filterAliases = JSON.stringify(aliases.map(input => input.value));
      first.checked = aliases.some(input => input.checked);
      first.disabled = aliases.every(input => input.disabled);
      const aliasCount = aliases.reduce((total, input) => {
        const labelText = $('span', input.closest('label'))?.textContent || '';
        const match = labelText.match(/\((\d+)\)\s*$/);
        return total + Number(match?.[1] || 0);
      }, 0);
      $('span', first.closest('label')).textContent = `1.75 mm (${aliasCount})`;
      aliases.slice(1).forEach(input => input.closest('label').remove());
    });
    let filterTimer;
    const applyFilters = () => {
      clearTimeout(filterTimer);
      if (!filterForm.reportValidity()) return;
      const url = new URL(location.href);
      [...url.searchParams.keys()].forEach(key => { if (key.startsWith('filter.') || key === 'page' || key === 'sort_by') url.searchParams.delete(key); });
      const data = new FormData(filterForm);
      $$('[data-filter-aliases]', filterForm).forEach(input => {
        if (!input.checked) return;
        const other = data.getAll(input.name).filter(value => value !== input.value);
        data.delete(input.name);
        [...new Set([...other, ...JSON.parse(input.dataset.filterAliases)])].forEach(value => data.append(input.name, value));
      });
      for (const [key,value] of data) if (String(value).trim()) url.searchParams.append(key,value);
      location.assign(url.href);
    };
    filterForm.addEventListener('submit', e => { e.preventDefault(); applyFilters(); });
    filterForm.addEventListener('change', e => { if (e.target.type === 'checkbox' || e.target.tagName === 'SELECT') applyFilters(); });
    filterForm.addEventListener('input', e => {
      if (!['number','text','search'].includes(e.target.type)) return;
      clearTimeout(filterTimer); filterTimer = setTimeout(applyFilters, 700);
    });
    $('select[form="gaminuFilters"]')?.addEventListener('change', applyFilters);
  }
  // Only discard empty rich-text spacers, never meaningful text, images or tables.
  function tidyRichText(scope = document) {
    $$('.rte p', scope).forEach(p => {
      if (!p.textContent.replace(/\u00a0/g,' ').trim() && !p.querySelector('img,video,iframe,svg,input,table')) p.remove();
    });
  }
  tidyRichText();
  document.addEventListener('shopify:section:load', e => tidyRichText(e.target));

  const mainImage = $('#gaminuMainMedia img');
  function setImage(url) { if (!mainImage || !url) return; mainImage.removeAttribute('srcset'); mainImage.removeAttribute('sizes'); mainImage.src = url; }
  $$('.thumb[data-gaminu-image]').forEach(button => button.addEventListener('click', () => { $$('.thumb').forEach(el => el.classList.toggle('active', el === button)); setImage(button.dataset.gaminuImage); }));
  const qty = $('#gaminuQty');
  const productForm = $('.product-form-main[data-gaminu-cart-form]');
  const quantityValue = value => {
    if (!qty) return value;
    const min = Number(qty.min || 1);
    const max = finiteNumber(qty.max);
    return Math.max(min, max == null ? value : Math.min(max, value));
  };
  $('[data-qty-minus]')?.addEventListener('click', () => {
    if (!qty || qty.disabled) return;
    qty.value = String(quantityValue(Number(qty.value || qty.min || 1) - Number(qty.step || 1)));
    syncProductStockUi(productForm, currentCart);
  });
  $('[data-qty-plus]')?.addEventListener('click', () => {
    if (!qty || qty.disabled) return;
    qty.value = String(quantityValue(Number(qty.value || qty.min || 1) + Number(qty.step || 1)));
    syncProductStockUi(productForm, currentCart);
  });
  qty?.addEventListener('input', () => syncProductStockUi(productForm, currentCart));
  qty?.addEventListener('change', () => {
    qty.value = String(quantityValue(Number(qty.value || qty.min || 1)));
    syncProductStockUi(productForm, currentCart);
  });
  $('#gaminuVariant')?.addEventListener('change', async e => {
    const option = e.target.selectedOptions[0];
    const form = e.target.form;
    const price = $('#gaminuProductPrice');
    if (price) price.innerHTML = `<span class="price">${escape(option.dataset.price)}</span>${option.dataset.compare ? `<span class="compare">${escape(option.dataset.compare)}</span>` : ''}`;
    const skuValue = $('#gaminuSku');
    if (skuValue) skuValue.textContent = option.dataset.sku || '';
    const skuLabel = $('#gaminuSkuLabel');
    if (skuLabel) skuLabel.textContent = option.dataset.hasSku === 'true'
      ? t('SKU', 'Prekės kodas')
      : t('PRODUCT REF.', 'Prekės kodas');

    form.dataset.variantId = option.value;
    form.dataset.stockTracked = option.dataset.stockTracked || 'false';
    form.dataset.stockCount = option.dataset.stockCount || '0';
    form.dataset.stockLimit = option.dataset.max || '';
    form.dataset.sellable = option.dataset.sellable || option.dataset.available || 'false';
    // Identify the exact selected variant in the pre-filled Contact US request.
    const restockLink = $('#gaminuRestockLink');
    if (restockLink) {
      const restockUrl = new URL(restockLink.href, location.origin);
      restockUrl.searchParams.set('variant', option.dataset.variantTitle || '');
      restockUrl.searchParams.set('variant_id', option.value);
      restockLink.href = restockUrl.href;
    }
    rememberInventory(option.value, {
      isPrinter: form.dataset.isPrinter === 'true',
      tracked: form.dataset.stockTracked === 'true',
      stock: finiteNumber(form.dataset.stockCount),
      limit: finiteNumber(form.dataset.stockLimit),
      sellable: form.dataset.sellable === 'true'
    });

    if (qty) {
      qty.min = option.dataset.min || '1';
      qty.step = option.dataset.step || '1';
      qty.value = qty.min;
    }
    setImage(option.dataset.image);
    syncProductStockUi(form, currentCart);

    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState(null, '', url);

    try {
      const cart = await api('cart.js', {cache:'no-store'});
      renderCart(cart);
      syncCartPage(cart);
    } catch { /* The selected variant still keeps its Liquid-rendered stock state. */ }
  });
  // Shopify predictive search; submitting the form remains a normal Shopify search.
  $$('.gaminu-header-search').forEach(form => {
    const input = $('input[type=search]', form), results = document.createElement('div');
    results.className = 'search-suggestions'; form.append(results);
    let timer, controller;
    input.addEventListener('input', () => {
      clearTimeout(timer); controller?.abort();
      if (input.value.trim().length < 2) { results.classList.remove('open'); return; }
      timer = setTimeout(async () => {
        controller = new AbortController();
        try {
          const params = new URLSearchParams({q:input.value, 'resources[type]':'product', 'resources[limit]':'6'});
          const data = await api('search/suggest.json?' + params, {signal:controller.signal});
          const products = data.resources.results.products;
          results.innerHTML = products.map(p => { const price = predictivePrice(p); return `<a class="search-suggestion" href="${escape(p.url)}"><span class="search-suggestion-media">${p.image ? `<img src="${escape(p.image)}" alt="">` : '<i class="fa-solid fa-cube product-fallback"></i>'}</span><span class="search-suggestion-copy"><strong>${escape(p.title)}</strong><small>${escape(p.vendor)}</small></span>${price ? `<span class="search-suggestion-price">${escape(price)}</span>` : ''}</a>`; }).join('') + `<button type="submit" class="search-suggestion-all">${t('Show all search results','Rodyti visus paieškos rezultatus')} <i class="fa-solid fa-arrow-right"></i></button>`;
          results.classList.add('open');
        } catch(error) { if (error.name !== 'AbortError') { results.textContent = t('Search suggestions unavailable. Press Enter to search.', 'Pasiūlymai nepasiekiami. Spauskite Enter paieškai.'); results.classList.add('open'); } }
      }, 200);
    });
    document.addEventListener('click', e => { if (!form.contains(e.target)) results.classList.remove('open'); });
    input.addEventListener('keydown', e => { if (e.key === 'Escape') results.classList.remove('open'); });
  });
  // Fixed header with a measured spacer: independent of ancestor overflow styles.
  const header = $('#siteHeader');
  if (header) {
    const spacer = document.createElement('div');
    spacer.className = 'gaminu-header-spacer'; spacer.setAttribute('aria-hidden', 'true');
    header.after(spacer); header.classList.add('gaminu-header-fixed');
    const measureHeader = () => {
      const height = Math.ceil(header.getBoundingClientRect().height);
      spacer.style.height = `${height}px`;
      html.style.setProperty('--gaminu-header-height', `${height}px`);
    };
    measureHeader();
    if ('ResizeObserver' in window) new ResizeObserver(measureHeader).observe(header);
    else window.addEventListener('resize', measureHeader, {passive:true});

    const progress = $('#scrollProgress');
    const updateHeaderState = () => {
      header.classList.toggle('scrolled', window.scrollY > 16);
      if (!progress) return;
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      const value = max > 0 ? Math.max(0, Math.min(100, window.scrollY / max * 100)) : 0;
      progress.style.width = `${value}%`;
    };
    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, {passive:true});
    window.addEventListener('resize', updateHeaderState, {passive:true});
  }

  // Use the real cards once; reverse smoothly at either end instead of cloning forms.
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const carousels = new Map();
  let carouselFrame = 0, previousFrame = 0;
  function scheduleCarousels() {
    if (!carouselFrame && !document.hidden && !reducedMotion.matches && [...carousels.values()].some(s => s.visible && (!s.paused || s.resumeAt > 0 || Math.abs(s.speed) > .1))) {
      carouselFrame = requestAnimationFrame(animateCarousels);
    }
  }
  function animateCarousels(now) {
    carouselFrame = 0;
    const dt = previousFrame ? Math.min((now - previousFrame) / 1000, .05) : 0;
    previousFrame = now;
    for (const [element, state] of carousels) {
      if (!element.isConnected) { carousels.delete(element); continue; }
      if (now >= state.resumeAt) state.resumeAt = 0;
      state.paused = state.hover || state.focus || state.touch || now < state.resumeAt;
      if (!state.visible || reducedMotion.matches || document.hidden) { state.speed = 0; continue; }
      const max = element.scrollWidth - element.clientWidth;
      if (max < 2) { state.speed = 0; continue; }
      if (element.scrollLeft >= max - 1) state.direction = -1;
      else if (element.scrollLeft <= 1) state.direction = 1;
      const target = state.paused ? 0 : 24 * state.direction;
      state.speed += (target - state.speed) * (1 - Math.exp(-dt / .18));
      if (state.paused && Math.abs(state.speed) < .1) state.speed = 0;
      if (state.speed) { state.position += state.speed * dt; state.position = Math.max(0, Math.min(max, state.position)); element.scrollLeft = state.position; }
    }
    scheduleCarousels();
    if (!carouselFrame) previousFrame = 0;
  }
  const carouselObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { const state = carousels.get(entry.target); if (state) { state.visible = entry.isIntersecting; if (!state.visible) state.speed = 0; } });
    scheduleCarousels();
  }, {threshold:0.05}) : null;
  function initCarousels(scope = document) {
    $$('.gaminu-home-carousel, .product-carousel', scope).forEach(element => {
      if (carousels.has(element)) return;
      element.tabIndex = 0;
      element.setAttribute('role', 'region');
      element.setAttribute('aria-label', t('Products: scroll horizontally', 'Prekės: slinkite horizontaliai'));
      const state = {position:element.scrollLeft, speed:0, direction:1, visible:!carouselObserver, hover:false, focus:false, touch:false, paused:false, resumeAt:0};
      carousels.set(element, state);
      function update() { state.paused = state.hover || state.focus || state.touch; scheduleCarousels(); }
      element.addEventListener('pointerenter', e => { if (e.pointerType !== 'touch') { state.hover = true; update(); } });
      element.addEventListener('pointerleave', () => { state.hover = false; update(); });
      element.addEventListener('focusin', () => { state.focus = true; state.speed = 0; update(); });
      element.addEventListener('focusout', e => { if (!element.contains(e.relatedTarget)) { state.focus = false; update(); } });
      element.addEventListener('pointerdown', () => { state.touch = true; state.speed = 0; update(); }, {passive:true});
      const release = () => { state.touch = false; state.position = element.scrollLeft; state.resumeAt = performance.now() + 1800; update(); };
      window.addEventListener('pointerup', () => { if (state.touch) release(); }, {passive:true});
      element.addEventListener('pointercancel', release, {passive:true});
      element.addEventListener('wheel', () => { state.speed = 0; state.resumeAt = performance.now() + 1800; scheduleCarousels(); }, {passive:true});
      element.addEventListener('scroll', () => { if (!state.speed) state.position = element.scrollLeft; }, {passive:true});
      carouselObserver?.observe(element);
    });
    scheduleCarousels();
  }
  initCarousels();
  document.addEventListener('shopify:section:load', e => initCarousels(e.target));
  document.addEventListener('shopify:section:unload', e => {
    for (const element of carousels.keys()) if (e.target.contains(element)) { carouselObserver?.unobserve(element); carousels.delete(element); }
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { cancelAnimationFrame(carouselFrame); carouselFrame = 0; previousFrame = 0; carousels.forEach(s => s.speed = 0); }
    else scheduleCarousels();
  });
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) { cancelAnimationFrame(carouselFrame); carouselFrame = 0; previousFrame = 0; carousels.forEach(s => s.speed = 0); }
    else scheduleCarousels();
  });

  // Clean visible typography, including catalog text and content inserted by apps.
  // Never rewrite markup, URLs, form values, source code or editable text.
  const cleanDashes = text => text.replace(/(Pristatymas per 4–7 d\. d\.|Delivery in 4–7 business days)|(\d)[\u2013\u2014](?=\d)|\s*[\u2013\u2014]\s*/g, (match, delivery, digit) => delivery || (digit ? digit + ' / ' : ' '));
  const protectedText = 'script,style,noscript,textarea,input,pre,code,[contenteditable],svg';
  function cleanTextNode(node) {
    if (!node.parentElement || node.parentElement.closest(protectedText) || !/[\u2013\u2014]/.test(node.nodeValue)) return;
    const cleaned = cleanDashes(node.nodeValue);
    if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
  }
  function cleanVisibleText(scope) {
    if (scope.nodeType === Node.TEXT_NODE) { cleanTextNode(scope); return; }
    if (scope.nodeType !== Node.ELEMENT_NODE || scope.closest(protectedText)) return;
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) cleanTextNode(node);
    [scope, ...scope.querySelectorAll('[data-roll-copy]')].forEach(element => {
      if (element.hasAttribute('data-roll-copy')) element.dataset.rollCopy = cleanDashes(element.dataset.rollCopy);
    });
  }
  cleanVisibleText(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') cleanTextNode(record.target);
      else record.addedNodes.forEach(cleanVisibleText);
    }
  }).observe(document.body, {subtree:true, childList:true, characterData:true});

  // Full-document Shopify navigation with the reference's upward curtain transition.
  const pageTransition = $('#gaminuPageTransition');
  let navigating = false;
  const resetTransition = () => { navigating = false; pageTransition?.classList.remove('is-leaving'); };
  window.addEventListener('pageshow', resetTransition);
  document.addEventListener('click', e => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || reducedMotion.matches || window.Shopify?.designMode) return;
    const link = e.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self') || link.hasAttribute('data-no-transition')) return;
    const url = new URL(link.href, location.href);
    if (!/^https?:$/.test(url.protocol) || url.origin !== location.origin || url.hash || /\/(cart|checkout|checkouts|account|apps)(\/|$)/.test(url.pathname)) return;
    if (url.href === location.href || !pageTransition) return;
    e.preventDefault(); if (navigating) return;
    navigating = true; pageTransition.classList.add('is-leaving');
    setTimeout(() => location.assign(url.href), 280);
    // Recover if navigation is cancelled by the browser or another application.
    setTimeout(resetTransition, 4000);
  });

  function initHeroSlider(scope = document) {
    $$('[data-gaminu-hero-slider]', scope).forEach(slider => {
      if (slider.dataset.heroReady === 'true') return;
      const slides = $$('[data-hero-slide]', slider);
      const dots = $$('[data-hero-dot]', slider);
      const progress = $('[data-hero-progress]', slider);
      if (!slides.length) return;

      const duration = Math.max(2000, Number(slider.dataset.interval || 8000));
      let index = 0;
      let start = performance.now();
      let raf = 0;
      let timer = 0;
      let paused = false;

      const setProgress = fraction => {
        if (progress) progress.style.transform = `scaleX(${Math.max(0, Math.min(1, fraction))})`;
      };

      const showSlide = newIndex => {
        index = (newIndex + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
        start = performance.now();
        setProgress(0);
      };

      const tick = now => {
        raf = 0;
        if (!paused) {
          const elapsed = now - start;
          const fraction = elapsed / duration;
          setProgress(fraction);
          if (elapsed >= duration) {
            showSlide(index + 1);
          }
        }
        raf = requestAnimationFrame(tick);
      };

      const resume = () => {
        paused = false;
        start = performance.now() - ((progress?.style.transform.match(/scaleX\(([^)]+)\)/)?.[1] || 0) * duration);
      };

      slider.addEventListener('pointerenter', () => { paused = true; });
      slider.addEventListener('pointerleave', () => { resume(); });
      slider.addEventListener('focusin', () => { paused = true; });
      slider.addEventListener('focusout', e => { if (!slider.contains(e.relatedTarget)) resume(); });

      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => showSlide(dotIndex));
      });

      showSlide(0);
      raf = requestAnimationFrame(tick);
      slider.dataset.heroReady = 'true';
      slider._heroDestroy = () => { if (raf) cancelAnimationFrame(raf); if (timer) clearTimeout(timer); };
    });
  }
  initHeroSlider();
  document.addEventListener('shopify:section:load', e => initHeroSlider(e.target));
  document.addEventListener('shopify:section:unload', e => {
    $$('[data-gaminu-hero-slider]', e.target).forEach(slider => slider._heroDestroy?.());
  });


  /* Animate UI inspired star fields, implemented in vanilla canvas for Shopify. */
  const gaminuStarFields = new Map();

  function gaminuStarPalette() {
    const dark = document.documentElement.dataset.theme === 'dark';
    return dark
      ? { star: [244, 238, 250], accent: [166, 104, 211] }
      : { star: [104, 83, 119], accent: [111, 58, 151] };
  }

  function createGaminuStarField(canvas, mode) {
    if (!canvas || gaminuStarFields.has(canvas)) return;
    const zone = canvas.parentElement;
    const ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx || !zone) return;

    const field = {
      canvas, zone, ctx, mode,
      width: 0, height: 0, dpr: 1,
      stars: [], raf: 0, last: performance.now(),
      pointer: { x: 0, y: 0, active: false },
      resizeObserver: null,
      destroyed: false
    };
    gaminuStarFields.set(canvas, field);

    const desiredCount = () => {
      if (mode === 'gravity') return Math.max(50, Math.min(82, Math.round(field.width * field.height / 15000)));
      return Math.max(44, Math.min(96, Math.round(field.width * field.height / 12000)));
    };

    const resetStar = (star, randomY = true) => {
      star.x = Math.random() * Math.max(1, field.width);
      star.y = randomY ? Math.random() * Math.max(1, field.height) : field.height + 8;
      star.r = mode === 'gravity' ? .65 + Math.random() * 1.45 : .55 + Math.random() * 1.75;
      star.alpha = .32 + Math.random() * .58;
      star.phase = Math.random() * Math.PI * 2;
      star.twinkle = .45 + Math.random() * 1.25;
      star.accent = Math.random() > .74;
      if (mode === 'gravity') {
        const angle = Math.random() * Math.PI * 2;
        const speed = 2.5 + Math.random() * 7;
        star.vx = Math.cos(angle) * speed;
        star.vy = Math.sin(angle) * speed;
      } else {
        star.vx = (Math.random() - .5) * 2.4;
        star.vy = -(5 + Math.random() * 17);
      }
    };

    const syncStars = () => {
      const count = desiredCount();
      while (field.stars.length < count) {
        const star = {};
        resetStar(star, true);
        field.stars.push(star);
      }
      if (field.stars.length > count) field.stars.length = count;
    };

    const resize = () => {
      const rect = zone.getBoundingClientRect();
      field.width = Math.max(1, rect.width);
      field.height = Math.max(1, rect.height);
      field.dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(field.width * field.dpr);
      canvas.height = Math.round(field.height * field.dpr);
      canvas.style.width = `${field.width}px`;
      canvas.style.height = `${field.height}px`;
      ctx.setTransform(field.dpr, 0, 0, field.dpr, 0, 0);
      syncStars();
    };

    const pointerMove = e => {
      if (mode !== 'gravity') return;
      const rect = zone.getBoundingClientRect();
      field.pointer.x = e.clientX - rect.left;
      field.pointer.y = e.clientY - rect.top;
      field.pointer.active = field.pointer.x >= 0 && field.pointer.x <= rect.width && field.pointer.y >= 0 && field.pointer.y <= rect.height;
    };
    const pointerLeave = () => { field.pointer.active = false; };

    zone.addEventListener('pointermove', pointerMove, { passive: true });
    zone.addEventListener('pointerleave', pointerLeave, { passive: true });

    const draw = now => {
      if (field.destroyed) return;
      const dt = Math.min((now - field.last) / 1000, .04);
      field.last = now;
      const palette = gaminuStarPalette();
      ctx.clearRect(0, 0, field.width, field.height);

      for (const star of field.stars) {
        if (!reducedMotion.matches) {
          if (mode === 'gravity') {
            if (field.pointer.active) {
              const dx = field.pointer.x - star.x;
              const dy = field.pointer.y - star.y;
              const distSq = dx * dx + dy * dy;
              const influence = 165;
              if (distSq > 1 && distSq < influence * influence) {
                const dist = Math.sqrt(distSq);
                const pull = (1 - dist / influence) * 34;
                star.vx += dx / dist * pull * dt;
                star.vy += dy / dist * pull * dt;
              }
            }
            const damping = Math.pow(.985, dt * 60);
            star.vx *= damping;
            star.vy *= damping;
            star.x += star.vx * dt;
            star.y += star.vy * dt;
            if (star.x < -8) star.x = field.width + 8;
            if (star.x > field.width + 8) star.x = -8;
            if (star.y < -8) star.y = field.height + 8;
            if (star.y > field.height + 8) star.y = -8;
          } else {
            star.x += star.vx * dt;
            star.y += star.vy * dt;
            if (star.y < -10 || star.x < -10 || star.x > field.width + 10) resetStar(star, false);
          }
        }

        const twinkle = .72 + Math.sin(now * .001 * star.twinkle + star.phase) * .28;
        const alpha = Math.max(.08, star.alpha * twinkle);
        const rgb = star.accent ? palette.accent : palette.star;
        const glow = mode === 'gravity' ? 10 + star.r * 4 : 5 + star.r * 3;

        ctx.beginPath();
        ctx.fillStyle = `rgba(${rgb[0]},${rgb[1]},${rgb[2]},${alpha})`;
        ctx.shadowColor = `rgba(${palette.accent[0]},${palette.accent[1]},${palette.accent[2]},${alpha * .7})`;
        ctx.shadowBlur = glow;
        ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.shadowBlur = 0;
      field.raf = requestAnimationFrame(draw);
    };

    field.resizeObserver = new ResizeObserver(resize);
    field.resizeObserver.observe(zone);
    resize();
    field.raf = requestAnimationFrame(draw);

    field.destroy = () => {
      field.destroyed = true;
      cancelAnimationFrame(field.raf);
      field.resizeObserver?.disconnect();
      zone.removeEventListener('pointermove', pointerMove);
      zone.removeEventListener('pointerleave', pointerLeave);
      gaminuStarFields.delete(canvas);
    };
  }

  function initGaminuStarFields(scope = document) {
    $$('[data-gaminu-stars]', scope).forEach(canvas => createGaminuStarField(canvas, 'stars'));
  }
  initGaminuStarFields();
  document.addEventListener('shopify:section:load', e => initGaminuStarFields(e.target));
  document.addEventListener('shopify:section:unload', e => {
    $$('[data-gaminu-stars]', e.target).forEach(canvas => gaminuStarFields.get(canvas)?.destroy?.());
  });



})();
